<template>
<v-card elevation="0">
    <v-card-text>
    <v-data-table :headers="headers"
        :items="areas"
        sort-by="name"
        class="elevation-1"
    >
        <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title>Area/Propinsi</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field v-model="keyword" placeholder="Cari..." hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog scrollable v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                        New Item
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.code" label="Kode" :readonly="editedIndex>-1"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.name" label="Nama"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.lat" label="Latitude"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.lng" label="Longitude"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                            Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
            </v-icon>
            <!-- <v-icon small @click="deleteItem(item)">
                mdi-delete
            </v-icon> -->
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Kode', align: 'start', sortable: false, value: 'code',
        },
        { text: 'Nama Area/Propinsi', value: 'name' },
        { text: 'Latitude', value: 'lat' },
        { text: 'Longitude', value: 'lng' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        lat: '',
        lng: '',
      },
      defaultItem: {
        name: '',
        lat: '',
        lng: '',
      },
      areas: [],
      keyword: '',
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    //   areas() {
    //       return this.$store.state.area.objs
    //   }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      keyword(val) {
        if (!val) val = ''
        this.areas = this.$store.state.area.objs.filter((el) => {
          console.log(val)
          // return el.name == "Trail Hambalang" //.includes(val)
          return el.name.toLowerCase().includes(val.toLowerCase()) 
        })
      }

    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('area/getObjs').then(response => {
            this.areas = response
        })
      },

      editItem (item) {
        this.editedIndex = this.areas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.areas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.areas.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.areas[this.editedIndex], this.editedItem)
        } else {
          this.areas.push(this.editedItem)
        }
        delete this.editedItem._id
        console.log(this.editedItem)
        let payload = this.editedItem
        payload.location = {
          type: "Point",
          coordinates: [Number(this.editedItem.lng), Number(this.editedItem.lat)]
        }
        // delete payload.lat
        // delete payload.lng

        console.log(payload)
        
        this.$store.dispatch('area/postObj', payload).then(response => {
            console.log(response)
            this.close()
        }, err => {
            console.log(err)
            this.close()
        })
      },
    },
  }
</script>